import { useMemo } from "react";

import { useIntl } from "react-intl";

import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { CofConfigId, type LensDestination } from "../../gql-generated/types";
import { useLensFolderPermissions } from "../../shared/hooks/roles";
import { type ApolloResult } from "../../shared/models";
import { allFalseConfig, makeLensActionsState } from "../state";
import { type LensActionsState } from "../state/LensActionsState";

import { type LensProps } from "./LensProps";

export const useLensActionsState = (
    lensProps: LensProps,
    destinations: readonly LensDestination[] = [],
): ApolloResult<{ actionsState: LensActionsState }> => {
    const intl = useIntl();
    const { configs } = useFeatureGates();
    const lensMakerDebugEnabled = configs[CofConfigId.MyLensesLensMakerDebug].enabled;

    const { lensFolderPermissions, loading, error } = useLensFolderPermissions(
        lensProps.lensAccountId?.lensSpaceId ?? "",
    );

    const actionsState = useMemo(
        () =>
            loading
                ? {
                      actionsConfig: allFalseConfig,
                      lensActionsErrorMap: {},
                  }
                : makeLensActionsState(lensProps, destinations, intl, lensFolderPermissions, lensMakerDebugEnabled),
        [destinations, intl, lensFolderPermissions, lensProps, loading, lensMakerDebugEnabled],
    );

    return {
        actionsState,
        loading,
        error,
    };
};
